import styled from 'react-emotion';

export const Wrapper = styled.div`
	color: #fff;
	text-align: left;
`

export const Title = styled.div`
	font-size: 1.5rem;
	font-weight: bold;
	margin-bottom: 1rem;
`

export const Subtitle = styled.div`
	font-size: 1.125rem;
	font-weight: bold;
	margin-bottom: 0.5rem;
`

export const Button = styled.a`
	background: ${props => props.reverse ? props.theme.color : '#fff'};
	border-radius: 2px;
	color: ${props => props.reverse ? '#fff' : props.theme.color};
	display: inline-block;
	font-size: 0.875rem;
	line-height: 2;
	padding: 0 0.75rem;
	margin: 1rem 0 0;
	text-decoration: none;
`

export const List = styled.ul`
	line-height: 1.85;
	list-style-type: none;
	margin: 0;
	padding: 0;
`

export const Link = styled.a`
	color: inherit;
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}
`
